import type {
  NetworkContributionDetail,
  NetworkContributionDetailSelectionParams,
} from '@gozoki/api-types'

import { gozokiApiWithAuth } from '../gozokiApi'

export const fetchNetworkContributionDetail = async (
  selection: NetworkContributionDetailSelectionParams,
): Promise<NetworkContributionDetail> => {
  const params: Record<string, string> = {}
  if (selection.storeIds?.length) params.storeIds = selection.storeIds.join(',')
  if (selection.storeAgeFilter) params.storeAgeFilter = selection.storeAgeFilter
  if (selection.ageStoreIds !== undefined)
    params.ageStoreIds = selection.ageStoreIds.length ? selection.ageStoreIds.join(',') : ''
  if (selection.startDate) params.startDate = selection.startDate
  if (selection.endDate) params.endDate = selection.endDate
  if (selection.comparableStartDate) params.comparableStartDate = selection.comparableStartDate
  if (selection.comparableEndDate) params.comparableEndDate = selection.comparableEndDate

  const response = await gozokiApiWithAuth.get<NetworkContributionDetail>(
    '/stores/get-network-contribution-detail',
    { params: Object.keys(params).length ? params : undefined },
  )
  return response.data
}
